import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-list-clearance",
  "use": "icon-ic-list-clearance-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-list-clearance\"><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0zm0 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm4.16-13c.36 0 .46-.22.22-.49L12.44 4.2a.6.6 0 0 0-.89 0L7.62 8.51c-.24.26-.15.49.22.49H11v6H7.84c-.37 0-.46.23-.22.49l3.93 4.32a.6.6 0 0 0 .89 0l3.93-4.32c.25-.27.15-.49-.22-.49H13V9h3.16z\" fill=\"#007FBA\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol